import { render, staticRenderFns } from "./product-reviews.vue?vue&type=template&id=10a1e579&scoped=true&"
import script from "./product-reviews.vue?vue&type=script&lang=js&"
export * from "./product-reviews.vue?vue&type=script&lang=js&"
import style0 from "./product-reviews.vue?vue&type=style&index=0&id=10a1e579&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a1e579",
  null
  
)

export default component.exports